module.exports = __webpack_public_path__ + "assets/7f8049d8554d5d4e749e28a87c1504ad.mp3";